export interface ByDate {
	Client_Name: string;
	AgentId: string;
	company: number;
	DebtCustCode: string;
	yy: number;
	mm: number;
	tothov: number;
}

export interface ByDateDisplay extends Partial<ByDate> {
	date: string;
	tothov: number;
}

export interface ByClient {
	id: string;
	name: string;
	tothov: number;
}

export interface BizoimGviaResponse {
	cm: number;
	yy1: string;
	tsum: number;
	cash: number;
}

export type DebtSummedPerAgentAndClient = {
	AgentName: string;
	CustAgentCode: string;
	AM: number;
	AO: number;
	DSP: number;
	BCU: number;
	BCO: number;
	CPL: string;
	DocTypeName: string;
	DocType: number;
	ClientId: string;
	Client_Name: string;
	Ldt: string;
	CustCity: string;
	CustEMail?: string;
	Address: string;
	CustDiscount: number;
	CMC: number;
	Cm: string;
	COC: number;
	COD: number;
	PTN: string;
	CustVat: number;
	HM: number;
	CE1?: string;
	CE2?: string;
	CE3?: string;
	CE4?: string;
	CE5?: string;
	Hearot: string;
	Phone: string;
	company: number;
	CC: string;
};

export type TDashDocSub = {
	tn: string;
	dn: string;
	date1: string;
	qty: number;
	pack: number;
	prc: number;
	dsc: number;
};

export type ClientWalkOrder = {
	ClientID: string;
	ClientName: string;
	AgentID: string;
	Sunday: string;
	Monday: string;
	Tuesday: string;
	Wednesday: string;
	Thursday: string;
	Friday: string;
	Saturday: string;
	WalkOrder: string;
};

export type ClientWalkOrderPossibleDays = 'Sunday' | 'Monday' | 'Tuesday' | 'Wednesday' | 'Thursday' | 'Friday' | 'Saturday';
export type ClientWalkOrderPossibleValues = '0' | '1' | '2' | '3' | '4' | '5' | '6' | '7';

export const clientWalkOrderValues: Array<{ value: ClientWalkOrderPossibleValues; text: string }> = [
	{ value: '7', text: 'פעם בחודש שבוע 1' },
	{ value: '5', text: 'פעם בחודש שבוע 2' },
	{ value: '3', text: 'פעם בחודש שבוע 3' },
	{ value: '4', text: 'פעם בחודש שבוע 4' },
	{ value: '2', text: 'פעמיים בחודש שבוע 1+3' },
	{ value: '6', text: 'פעמיים בחודש שבוע 2+4' },
	{ value: '1', text: 'כל שבוע' },
	{ value: '0', text: 'לא במסלול' },
];

export type ClientWalkOrderPatchBody = {
	ClientID: string;
	WalkOrder?: string;
	day?: ClientWalkOrderPossibleDays;
	dayValue?: string;
};
